import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from '../../services/apiUrls';
import { getBestsellersData, getSalesOverviewData, getParametersData, getChannelReportData, getSalesByPaymentModeData, getSalesByRevenueData, getOnlineSalesData,
  getSalesDiscountsData, saveBestsellerItemsData, saveBestsellerCategoriesData, saveBestsellerSubCategoriesData, saveBestsellerBranchesData, saveBestsellerBrandsData,
  saveSalesOverviewData, saveParametersData, saveSalesByPaymentModeData, saveSalesByRevenueData, saveOnlineSalesData, saveSalesDiscountsData, getRankingsData, getSalesStatusData, 
  saveSalesStatusData, getAvgSellingPrice, saveAvgSellingPrice, getSalesTransactions, saveSalesTransactions, getCurrentSale, saveCurrentSale, getOOSItems, saveOOSItems, saveRealTimeLastUpdate
} from '../slices';
import moment from "moment";
import { DATE_TIME_FORMATS } from "../../data/constants";

export interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string
  code?: string
}

function* fetchBestsellersData(actions:any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getBestsellers(actions.payload.entity),
      data: actions.payload.dataToPost
    })
    if (actions.payload.entity === 'item') {
      yield put(saveBestsellerItemsData(response));
    } else if (actions.payload.entity === 'category') {
      yield put(saveBestsellerCategoriesData(response))
    } else if (actions.payload.entity === 'subcategory') {
      yield put(saveBestsellerSubCategoriesData(response))
    }
  } catch (error) {
    console.log(error);
  }
}

function* fetchRankingsData(actions:any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getRankings(actions.payload.entity),
      data: actions.payload.dataToPost
    })
    if (actions.payload.entity === 'branch') {
      yield put(saveBestsellerBranchesData(response))
    } else if (actions.payload.entity === 'brand') {
      yield put(saveBestsellerBrandsData(response))
    }
  } catch (error) {
    console.log(error);
  }
}

function* fetchSalesOverviewData(actions:any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getSalesOverview(),
      data: actions.payload.dataToPost
    })
    yield put(saveSalesOverviewData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchParametersData(actions:any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getParameters,
      data: actions.payload.dataToPost
    })
    yield put(saveParametersData(response))
  } catch (error) {
    console.log(error);
  }
}


function* fetchSalesByPaymentModeData(actions:any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getSalesByPaymentMode(),
      data: actions.payload.dataToPost
    })
    yield put(saveSalesByPaymentModeData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchSalesByRevenueData(actions:any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getSalesByRevenue(),
      data: actions.payload.dataToPost
    })
    yield put(saveSalesByRevenueData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchOnlineSalesData(actions:any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getOnlineSales(),
      data: actions.payload.dataToPost
    })
    yield put(saveOnlineSalesData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchSalesDiscountsData(actions:any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getSalesDiscounts(),
      data: actions.payload.dataToPost
    })
    yield put(saveSalesDiscountsData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchSalesStatusData(actions:any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getSalesStatus,
      data: actions.payload.dataToPost
    })
    yield put(saveSalesStatusData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchAvgSellingPrice(actions:any){
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getSellingPrice,
      data: actions.payload.dataToPost
    })
    yield put(saveAvgSellingPrice(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchSellTransaction(actions:any){
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getSellTransaction,
      data: actions.payload.dataToPost
    })
    yield put(saveSalesTransactions(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchCurrentSaleData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getCurrentSale,
      data: actions.payload?.dataToSend
    })
    if (!response?.code) {
      yield put(saveCurrentSale(response))
      yield put(saveRealTimeLastUpdate(moment().format(DATE_TIME_FORMATS.hourMinute)))
      actions.payload?.callback()
    }
    else {
      yield put(saveCurrentSale([]))
      yield put(saveRealTimeLastUpdate(''))
      actions.payload?.callback()
    }
  } catch (error) {
    console.log(error);
    actions.payload?.callback()
  }
}
function* fetchCurrentOOSItems(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.DASHBOARD.getOOSItems,
      data: actions.payload
    })
    if (!response?.code) {
      yield put(saveOOSItems(response))
    }
    else {
      yield put(saveOOSItems([]))
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getBestsellersData.type, fetchBestsellersData);
  yield takeEvery(getRankingsData.type, fetchRankingsData);
  yield takeEvery(getSalesOverviewData.type, fetchSalesOverviewData);
  yield takeEvery(getParametersData.type, fetchParametersData);
  yield takeEvery(getSalesByPaymentModeData.type, fetchSalesByPaymentModeData);
  yield takeEvery(getSalesByRevenueData.type, fetchSalesByRevenueData);
  yield takeEvery(getOnlineSalesData.type, fetchOnlineSalesData);
  yield takeEvery(getSalesDiscountsData.type, fetchSalesDiscountsData);
  yield takeEvery(getSalesStatusData.type, fetchSalesStatusData);
  yield takeEvery(getAvgSellingPrice.type, fetchAvgSellingPrice);
  yield takeEvery(getSalesTransactions.type, fetchSellTransaction);
  yield takeEvery(getCurrentSale.type, fetchCurrentSaleData)
  yield takeEvery(getOOSItems.type, fetchCurrentOOSItems)
}

